import store from '../../../reduxStore';
import { addStickyError } from '../../actions/alerts';
import { setRCEError } from '../../actions/rce';
import { isQuizBuilding, isQuizTaking } from '../../util/windowChecks';
import { userAlertMsgBuilding, userAlertMsgTaking } from './rceConfigErrorMessages';
var alertTheUser = function alertTheUser(message) {
  store.dispatch(addStickyError(message));
};
var getAlertMessage = function getAlertMessage() {
  return isQuizTaking() ? userAlertMsgTaking() : userAlertMsgBuilding();
};
var shouldAlertUser = function shouldAlertUser() {
  return isQuizTaking() || isQuizBuilding();
};
var shouldSetEventToQuizLog = function shouldSetEventToQuizLog() {
  return isQuizTaking();
};
export var handleError = function handleError(quizLogMessage) {
  if (shouldAlertUser()) {
    alertTheUser(getAlertMessage());
  }
  if (shouldSetEventToQuizLog()) {
    setEventToQuizLog(quizLogMessage);
  }
};
export var setEventToQuizLog = function setEventToQuizLog(message) {
  store.dispatch(setRCEError(message));
};